// Product Anchor Link functionality
document.addEventListener('DOMContentLoaded', function() {
    // Anchor link functionality
    const anchorLinks = document.querySelectorAll('.product__metafield-anchor-link');
    
    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('data-anchor-target');
            
            // Find the target element anywhere on the page
            const targetElement = document.querySelector(`[data-block-id="${targetId}"]`);
            
            if (targetElement) {
                // Account for fixed header if it exists
                const header = document.querySelector('header');
                const headerHeight = header ? header.offsetHeight : 0;
                const targetPosition = targetElement.offsetTop - headerHeight;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
                
                // Optional: Add focus for accessibility
                targetElement.focus();
            }
        });
    });
    
    // Also handle Shopify section reloads
    document.addEventListener('shopify:section:load', function() {
        const anchorLinks = document.querySelectorAll('.product__metafield-anchor-link');
        
        anchorLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                const targetId = this.getAttribute('data-anchor-target');
                
                // Find the target element anywhere on the page
                const targetElement = document.querySelector(`[data-block-id="${targetId}"]`);
                
                if (targetElement) {
                    // Account for fixed header if it exists
                    const header = document.querySelector('header');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const targetPosition = targetElement.offsetTop - headerHeight;
                    
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                    
                    // Optional: Add focus for accessibility
                    targetElement.focus();
                }
            });
        });
    });
}); 